import React from 'react'
import { useParams } from 'react-router-dom'
import SidePanel from 'transfix-ui/components/SidePanel'
import { Box, createStyles, Grid, makeStyles } from 'transfix-ui/core'
import Typography from 'transfix-ui/core/Typography'
import { brandColors, shadows, Tag, TAG_SIZE, TAG_STYLE, theme } from 'transfix-ui'
import { useGetCurrentParser } from '../hooks/useGetCurrentParser'
import { useGetCurrentParserVersion } from '../hooks/useGetCurrentParserVersion'
import { ParserDetails } from './ParserDetails'

interface IParserSideBarProps {
  onSidebarClose: () => void
}

const useParserSideBarStyles = makeStyles(() =>
  createStyles({
    card: {
      padding: theme.spacing(1),
      marginBottom: theme.spacing(2),
      boxShadow: shadows[3],
    },
    titleText: {
      display: 'flex',
      flex: theme.spacing(2),
      alignItems: 'center',
    },
    secondary: {
      color: brandColors.coolGray5,
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    tag: {
      marginRight: theme.spacing(1),
    },
  })
)

export const ParserSideBar = ({ onSidebarClose }: IParserSideBarProps) => {
  const classes = useParserSideBarStyles()
  const { parserId } = useParams<{ parserId: string }>()

  const parser = useGetCurrentParser(parserId)
  const parserVersion = useGetCurrentParserVersion(parser)

  return (
    <SidePanel anchor='right' onClose={onSidebarClose} PaperProps={{ style: { width: '45%' } }}>
      <Box mb={3} data-test='SidePanel'>
        <Grid container justifyContent='space-between' direction='row' alignItems='center'>
          <Grid item>
            <Typography variant='h2' className={classes.titleText}>
              <span data-test='parser-header'>{parser?.name} Parser </span>
            </Typography>
          </Grid>
          <Grid item alignItems='center'>
            <Tag
              data-test='parser-active-status'
              className={classes.tag}
              tagStyle={parserVersion?.is_live ? TAG_STYLE.success : TAG_STYLE.error}
              size={TAG_SIZE.small}
              label={parserVersion?.is_live ? 'Active' : 'Not Active'}
            />
          </Grid>
        </Grid>
      </Box>
      <hr />
      <ParserDetails liveParserVersion={parserVersion} />
    </SidePanel>
  )
}
